module.exports = __webpack_public_path__ + "static/media/12.651db917.png";